export enum AuthProviderType {
  GOOGLE = "google",
  AZURE_AD = "azure",
}
